exports.onRouteUpdate = (
  { location },
  pluginOptions = { stripQueryString: false, trailingSlash: false },
) => {
  const domElem = document.querySelector(`link[rel='canonical']`)
  if (domElem == null) return
  const existingValue = domElem.getAttribute('href')
  if (existingValue == null || existingValue === '') return
  const baseHref = domElem.getAttribute('data-basehref')
  if (baseHref == null || baseHref === '') return

  const { stripQueryString, trailingSlash } = pluginOptions

  const newHref = new URL(location.pathname.replace(/\/$/g, ''), baseHref)

  if (!stripQueryString) {
    newHref.search = location.search
  }

  if (trailingSlash) {
    newHref.pathname += '/'
  }

  newHref.hash = location.hash

  domElem.setAttribute('href', newHref.toString())
}
